/* eslint-disable react/destructuring-assignment */
// @ts-check
import { FilePdfOutlined, PlusOutlined } from "@ant-design/icons";
import { useLazyQuery, useQuery } from "@apollo/client";
import { Alert, Button, Input, message, Popover, Skeleton, Spin, Tooltip } from "antd";
import { isEmpty } from "lodash";
import React, { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { UserContext } from "../../../amplify/authenticator-provider";
import {
  GET_ENGAGEMENT_MESSAGE_TEMPLATES,
  GET_ENGAGEMENT_TEMPLATE_TEXT,
  GET_INITIAL_REVIEW_MESSAGE,
} from "../../../graphql/query";
import { resolveLeadOpportunityId } from "../../../helpers/opportunityHelper";
import AttachmentIcon from "../../../icons/js/AttachmentIcon";
import { BottomCalendarIcon } from "../../../icons/js/CalendarIcon";
import CarIcon from "../../../icons/js/CarIcon";
import { CodeBrackets, EmailWithSearch } from "../../../icons/js/EmailIcons";
import GIFIcon from "../../../icons/js/GIFIcon";
import OttoLinkIcon from "../../../icons/js/OttoLinkIcon";
import { EditPencilIcon } from "../../../icons/js/PencilIcon";
import { RemainderIcon21 } from "../../../icons/js/RemainderIcon";
import ReviewTemplateIcon from "../../../icons/js/ReviewTemplateIcon";
import SendIcon from "../../../icons/js/SendIcon";
import SmilyIconJSX from "../../../icons/js/SmilyIcon";
import TemplateIcon from "../../../icons/js/TemplateIcon";
import { AccessPermissionAction } from "../../../library/constants";
import { checkAccessPermission, openDialog } from "../../../library/helpers";
import { Actions } from "./BottomActions";
import EmojiPicker from "./mediaSharing/emojiPicker";
import GifPickerComponent from "./mediaSharing/gifPicker";
import MmsMediaButtons from "./mmsMediaButtons";
import { TEMPLATE_ENUMS } from "../../../constant/EmailConstant";
import useLang from "../../../hooks/useLang";
import VehicleDetailPage from "./VDP/VehicleDetailPage";

/**
 *
 * @param {{emailTextRef:any,buttonDisabled:()=>boolean,attachments:Array<any>,handleMediaSharing:(type:"image" | "video" | any)=>void,mediaRef:any,videoRef:any,documentRef:any,setAttachments:import("react").Dispatch<import("react").SetStateAction<Array>>,emailCursor:any,setEmailCursor:import("react").Dispatch<import("react").SetStateAction<any>>,emailForm:import("antd").FormInstance,addSignature:(string)=>void,showSend:boolean}} props
 * @returns
 */
export const EmailBottomActions = props => {
  const { showSend, disableSend = false, selectedOppTypeId } = props;
  // @ts-ignore
  const {
    textMode: textModeRedux,
    selectedLead,
    messageOpportunity,
    // @ts-ignore
  } = useSelector(state => state?.lead || {});
  const canShareVDP = checkAccessPermission(AccessPermissionAction.VDP_FEATURE_VIEW);
  const { user } = useContext(UserContext);
  const crmIntegrationType = user?.company?.crmIntegrationType;

  const [getMessageText, { loading: appointmentLinkLoading }] = useLazyQuery(
    GET_ENGAGEMENT_TEMPLATE_TEXT,
    {
      fetchPolicy: "cache-first",
    }
  );

  const [getReviewMessage, { loading: reviewInviteLoading }] = useLazyQuery(
    GET_INITIAL_REVIEW_MESSAGE,
    {
      fetchPolicy: "network-only",
    }
  );

  const [vdpDrawerOpen, setVdpDrawerOpen] = useState(false);

  const Attachments = () => {
    const mediaProps = {
      handleMediaSharing: type => props.handleMediaSharing(type),
      mediaRef: props.mediaRef,
      videoRef: props.videoRef,
      documentRef: props.documentRef,
    };
    const handleMediaEvent = async (e, attachments, setAttachments) => {
      const fileType = "";
      const { files } = e.target;
      const filesarr = [];
      if (e.target.files.length === 0) return;
      for (let i = 0; i < e.target.files.length; i++) {
        filesarr.push(e.target.files[i]);
      }
      if (filesarr.length > 0) {
        setAttachments([
          ...attachments,
          ...filesarr.map(item => {
            return {
              file: item,
              preview: URL.createObjectURL(item),
              generateLink: true,
            };
          }),
        ]);
      }
    };

    return (
      <div className="flex flex-col justify-center  gap-5">
        {!props.attachments.some(file => file?.file?.type?.includes("gif") || false) && (
          <MmsMediaButtons
            color="#64748B"
            {...mediaProps}
            handleMediaEvent={e => handleMediaEvent(e, props.attachments, props.setAttachments)}
          />
        )}{" "}
        {props.attachments.length === 0 && (
          <div key="gifPicker" className="icon-wrapper">
            <Popover
              showArrow={false}
              content={
                <div onClick={e => e.stopPropagation()}>
                  <GifPickerComponent
                    attachments={props.attachments}
                    setAttachments={props.setAttachments}
                    //   selectedLead={selectedLead}
                    // user={user}
                  />
                </div>
              }
              trigger="click"
              destroyTooltipOnHide
            >
              <span className="flex items-center justify-start cursor-pointer">
                <GIFIcon className="text-[20px] mr-1.5" />
                Select GIF
              </span>
            </Popover>
          </div>
        )}{" "}
      </div>
    );
  };
  /**
   *
   * @param {string} snippet
   */
  const handleInsertSnippetFn = snippet => {
    const container = document.getElementById("email-text-box-container");
    if (!container) {
      console.error("Parent container element not found");
      return;
    }
    const editor = container.querySelector("#rich-text");
    if (!editor) {
      console.error("Editor element not found within the container");
      return;
    }
    if (editor instanceof HTMLElement) {
      editor.focus(); // Ensure editor is focused
    } else {
      console.error("Editor element is not focusable");
    }

    if (!props.emailCursor) {
      console.error("Email cursor position is not defined");
      return;
    }

    const selection = window.getSelection();
    if (!selection) {
      console.error("Unable to get window selection");
      return;
    }
    selection.removeAllRanges();
    selection.addRange(props.emailCursor); // Restore cursor position

    // Split the URL string into individual URLs
    const urls = snippet.split("\n");
    // Insert each hyperlink at the restored cursor position
    urls.forEach(url => {
      const range = selection.getRangeAt(0);
      range.deleteContents(); // Remove any selected text

      const linkNode = document.createElement("a");
      linkNode.href = url.trim(); // Ensure no extra spaces in the URL
      linkNode.textContent = url.trim();
      linkNode.target = "_blank"; // Open link in a new tab
      range.insertNode(linkNode);

      // Add a line break after each link
      const lineBreakNode = document.createElement("br");
      range.insertNode(lineBreakNode);

      // Add a space after the line break
      const spaceNode = document.createTextNode("\n");
      range.insertNode(spaceNode);

      // Move cursor after the space
      range.setStartAfter(spaceNode);
      range.setEndAfter(spaceNode);
    });
  };
  const handleInsertSnippet = (snippet, isHtml = false) => {
    const container = document.getElementById("email-text-box-container");
    if (!container) {
      console.error("Parent container element not found");
      return;
    }
    const editor = container.querySelector("#rich-text");
    if (!editor) {
      console.error("Editor element not found within the container");
      return;
    }
    if (editor instanceof HTMLElement) {
      editor.focus(); // Ensure editor is focused
    } else {
      console.error("Editor element is not focusable");
    }

    if (!props.emailCursor) {
      console.error("Email cursor position is not defined");
      return;
    }

    const selection = window.getSelection();
    if (!selection) {
      console.error("Unable to get window selection");
      return;
    }
    selection.removeAllRanges();
    selection.addRange(props.emailCursor); // Restore cursor position

    // Insert snippet at restored cursor position
    const range = selection.getRangeAt(0);
    range.deleteContents(); // Remove any selected text

    if (isHtml) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = snippet;
      const fragment = document.createDocumentFragment();
      Array.from(tempDiv.childNodes).forEach(node => fragment.appendChild(node));
      range.insertNode(fragment);
    } else {
      const snippetNode = document.createTextNode(snippet);
      range.insertNode(snippetNode);
    }

    // Move cursor after inserted content
    range.collapse(false);
    selection.removeAllRanges();
    selection.addRange(range);
  };
  const handleSendAppointmentLink = async () => {
    // See BottomActions.handleSendAppointmentLink for the priority
    // rationale: leadOpportunityId pins to the picked opp; otherwise
    // oppTypeId scopes to the active tab; otherwise BE falls back.
    // ``selectedOppTypeId`` comes via prop when available, else we
    // read the window-global the tab strip publishes for SocketIO
    // filtering (engagementActivity.js sets __ACTIVE_OPP_TYPE_ID__
    // every time the tab changes), so the email surface picks up
    // the active tab without prop drilling all the way through
    // EmailTextWithBottom → ReplyEmail → ... .
    const resolvedLeadOppId = resolveLeadOpportunityId(messageOpportunity);
    const activeTabOppType =
      // eslint-disable-next-line no-underscore-dangle
      selectedOppTypeId || (typeof window !== "undefined" ? window.__ACTIVE_OPP_TYPE_ID__ : null);
    const res = await getMessageText({
      variables: {
        leadId: selectedLead?.id,
        content: `{createAppointmentUrl}`,
        leadOpportunityId: resolvedLeadOppId || null,
        oppTypeId: resolvedLeadOppId ? null : activeTabOppType || null,
      },
    });

    if (res?.data?.getEngagementTemplateText?.statusCode === 200) {
      handleInsertSnippet(res?.data?.getEngagementTemplateText?.content || "");
    } else {
      message.error(res?.data?.getEngagementTemplateText?.message);
    }
  };

  const handleReviewInvite = async () => {
    const res = await getReviewMessage({
      variables: {
        leadId: selectedLead.id,
        leadOpportunityId: resolveLeadOpportunityId(messageOpportunity),
      },
    });
    if (res?.data?.getInitialReviewMessage?.statusCode === 200) {
      handleInsertSnippet(res?.data?.getInitialReviewMessage?.content, true);
    } else {
      message.error("Failed to generate review message. Please contact support.");
    }
  };
  const OttoLinks = () => {
    return (
      <div className="flex flex-col justify-center gap-5">
        {crmIntegrationType === "EL" && (
          <span
            onClick={() => {
              openDialog("documentSelector", {
                width: "620px",
                dialogHeader: "Print Dealer Documents",
                // leadId: selectedLead?.id,
                // activeOppName: activeOppName,
                // opportunityList: opportunityList,
              });
            }}
            className="flex items-center justify-start cursor-pointer"
          >
            <FilePdfOutlined className="text-[20px] mr-1.5" />
            Print Dealer Document
          </span>
        )}

        <span
          onClick={() => handleSendAppointmentLink()}
          className="flex items-center justify-start cursor-pointer"
        >
          <BottomCalendarIcon className="text-[20px] mr-1.5" />
          Attach Appointment Link
        </span>
        <span
          onClick={() => handleReviewInvite()}
          className="flex items-center justify-start cursor-pointer"
        >
          <ReviewTemplateIcon className="text-[20px] mr-1.5" />
          Review Invite
        </span>
        {textModeRedux === "Text" && (
          <span
            // onClick={() => setTemplateModal({ visible: true })}
            className="flex items-center justify-start cursor-pointer"
          >
            <TemplateIcon className="text-[20px] mr-1.5" />
            Select Template
          </span>
        )}
        {canShareVDP && (
          <span
            onClick={() => setVdpDrawerOpen(true)}
            className="flex items-center justify-start cursor-pointer"
          >
            <CarIcon color="#64748B" className="text-[20px] mr-1.5" />
            VDP
          </span>
        )}
      </div>
    );
  };
  const EmailTemplate = props => {
    const [lang] = useLang();
    const [emailTemplates, setemailTemplates] = useState([]);
    const [search, setsearch] = useState("");
    const { loading: emailTemplateLoader } = useQuery(GET_ENGAGEMENT_MESSAGE_TEMPLATES, {
      variables: {
        companyId: +user.company.id,
        templateType: TEMPLATE_ENUMS.EMAIL,
        userId: +user.id,
        search: search, // Pass search term to the query
      },
      onCompleted: res => {
        const activeTemplates = res.engagementMessageTemplates;
        setemailTemplates(activeTemplates.filter(template => template.isActive));
      },
    });

    const [getEngagementTemplateText] = useLazyQuery(GET_ENGAGEMENT_TEMPLATE_TEXT);
    const parseTemplate = async template => {
      const payload = {
        content: template?.message,
        leadId: props?.leadId || selectedLead?.id,
      };
      const res = await getEngagementTemplateText({
        variables: payload,
      });
      if (res?.data?.getEngagementTemplateText?.statusCode !== 200) {
        message.error(res?.data?.getEngagementTemplateText?.message);
        return;
      }
      if (res?.data?.getEngagementTemplateText?.content && props?.setEmailBody) {
        props?.setEmailBody(
          `${res?.data?.getEngagementTemplateText?.content} 
            <br/>
            ${props?.body ? props?.body : ""}`
        );
        props?.emailForm?.setFieldValue("subject", template?.subject || "");
      } else {
        props?.emailTextRef?.current?.focus();
      }
    };
    return (
      <div className="p-2">
        <Input
          onClick={e => e.stopPropagation()}
          placeholder={lang?.searchTemplate}
          disabled={isEmpty(emailTemplates)}
          onChange={e => setsearch(e.target.value)}
        />
        <div className="flex-col-centered gap-1 mt-1">
          <Skeleton loading={emailTemplateLoader} active paragraph={{ rows: 4 }}>
            {!isEmpty(emailTemplates) ? (
              emailTemplates.map((option, index) => (
                <span
                  key={index}
                  onClick={e => {
                    // e.stopPropagation();
                    parseTemplate(option);
                  }}
                  className="p-1 cursor-pointer"
                >
                  {
                    // @ts-ignore
                    option?.title || ""
                  }
                </span>
              ))
            ) : (
              <p className="text-gray-500 m-0 mt-1">{lang?.noTemplates}</p>
            )}
          </Skeleton>
        </div>
      </div>
    );
  };

  const InsertFields = () => {
    const [search, setsearch] = useState("");
    const arr = [
      "{leadFullName}",
      "{leadFirstName}",
      "{locationName}",
      "{userFullName}",
      "{locationName}",
      "{question}",
    ];
    return (
      <div>
        <Input
          onChange={e => setsearch(e.target.value)}
          onClick={e => e.stopPropagation()}
          placeholder="Search snippets"
        />
        <div className="flex-col-centered gap-2">
          {arr
            .filter(item => (isEmpty(search) ? item : item.includes(search)))
            .map((item, index) => (
              <span
                onClick={e => {
                  e.stopPropagation();
                  handleInsertSnippet(item);
                }}
                className="cursor-pointer"
                key={index}
              >
                {item}
              </span>
            ))}
        </div>
      </div>
    );
  };
  const Signature = () => {
    return (
      <div className="flex flex-col justify-center gap-5">
        <span
          // onClick={() => handleSendReviewClick()}
          onClick={() =>
            openDialog("emailSignature", {
              dialogHeader: "Email Signature",
              width: "700px",
              mode: "EDIT",
              addSignature: props.addSignature,
            })
          }
          className="flex items-center justify-start cursor-pointer"
        >
          <EditPencilIcon color="#334155" className="text-[20px] mr-1.5" />
          Edit Signature
        </span>
        <span
          onClick={() =>
            openDialog("emailSignature", {
              dialogHeader: "Email Signature",
              width: "700px",
              mode: "ADD",
            })
          }
          className="flex items-center justify-start cursor-pointer"
        >
          <PlusOutlined className="text-[20px] mr-1.5" />
          Insert Signature
        </span>
      </div>
    );
  };

  const bottomActions = [
    {
      render: (
        <EmojiPicker
          key="emjoi_picker"
          handleSetDefinedTemplate={value => console.log(value)}
          //   text={text}
          //   messageText={messageText}
          emailCursor={props?.emailCursor}
          textMode={1}
          emailTextRef={props?.emailTextRef}
        />
      ),
      title: "Emoji",
      icon: <SmilyIconJSX color="black" />,
      autoCloseDisabled: true,
    },
    {
      render: <Attachments />,
      icon: <AttachmentIcon color="black" />,
      title: "Attach File",
    },
    {
      render: <OttoLinks />,
      icon: <OttoLinkIcon color="black" />,
      title: "Otto Links",
    },
    // {
    //   icon: <SignatureIcon />,
    //   render: <Signature />,
    //   title: "Add Signature",
    // },
    {
      icon: <div className="h-[20px] w-[2px] bg-gray-500" />,
      hover: false,
    },
    {
      icon: (
        <span className="flex-row-centered items-center gap-[7px]">
          <EmailWithSearch />
          <span className="text-grey-700 font-[400]">Use Template</span>
        </span>
      ),
      render: <EmailTemplate {...props} />,
      title: "Use Template",
    },
    {
      icon: (
        <span className="flex-row-centered items-center gap-[7px]">
          <CodeBrackets />
          <span className="text-grey-700 font-[400]">Insert Fields</span>
        </span>
      ),
      title: "Insert Fields",
      render: <InsertFields />,
    },
  ];
  const OptoutErrorMessage = "Lead has opted out, you cannot message this lead now!";
  const ErrorPopover = <Alert type="error" showIcon message={OptoutErrorMessage} />;
  return (
    <Spin spinning={appointmentLinkLoading || reviewInviteLoading}>
      <div className="flex-row-centered justify-between items-center py-3">
        <div className="flex-row-centered gap-2 items-center">
          {bottomActions.map((item, index) => {
            const actionProps = {
              buttonDisabled: props.buttonDisabled,
              ErrorPopover,
              item,
              hover: item.hover ?? true,
              index,
            };
            return <Actions key={index} {...actionProps} />;
          })}
        </div>
        {showSend && (
          <div className="flex-row-centered gap-2 items-center">
            <span className="flex-row-centered p-1 items-center justify-center hover:bg-[#E2E8F0] cursor-pointer rounded-[4px]">
              <RemainderIcon21 />
            </span>
            <Tooltip
              title={
                disableSend
                  ? "Total attachments exceed the email size limit. Remove or replace files before sending."
                  : ""
              }
            >
              <Button
                type="primary"
                disabled={disableSend}
                onClick={() => props.emailForm.submit()}
                className="bg-brand-500 flex-row-centered gap-1 items-center"
              >
                Send <SendIcon />
              </Button>
            </Tooltip>
          </div>
        )}
        {vdpDrawerOpen && (
          <VehicleDetailPage
            open={vdpDrawerOpen}
            onClose={() => setVdpDrawerOpen(false)}
            handleInsertLink={value => {
              handleInsertSnippetFn(value);
            }}
          />
        )}
      </div>
    </Spin>
  );
};
